import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { getNews } from "../../../../utils/services/user.service";
import {
  NewsWrapper,
  InnerContainer,
  HeaderRow,
  Title,
  ArrowButtons,
  ArrowButton,
  CarouselOuter,
  CarouselTrack,
  CarouselItem,
  NewsCard,
  NewsDate,
  NewsTitle,
  NewsExcerpt,
  DotsRow,
  Dot,
  SidebarOverlay,
  SidebarPanel,
  SidebarImageWrapper,
  SidebarImage,
  SidebarClose,
  SidebarBody,
  SidebarDate,
  SidebarTitle,
  SidebarContent,
  SidebarActions,
  SidebarButton,
  SidebarNavRow,
  SidebarNavButton,
} from "./News.styles";

export const News = () => {
  const [newsData, setNewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openSidebarIndex, setOpenSidebarIndex] = useState(null);

  const fetchNewData = async () => {
    setIsLoading(true);
    try {
      const response = await getNews();
      if (response?.data?.data) {
        setNewsData(response.data.data);
      } else {
        console.error("Error fetching news:", response?.statusText);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNewData();
  }, []);

  const items = useMemo(() => {
    if (!newsData || newsData.length === 0) {
      return [];
    }
    return newsData.map((n) => ({
      date: moment(n.createdAt).format("MMM YYYY"),
      title: n.title,
      excerpt: n.description,
      content: n.description,
      image:
        n.image ||
        "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?q=80&w=1200",
    }));
  }, [newsData]);

  const activeIndex = Math.min(selectedIndex, Math.max(0, items.length - 1));
  const activeItem = items[openSidebarIndex ?? -1] || null;

  const handleNext = () => {
    setSelectedIndex((i) => (items.length ? Math.min(items.length - 1, i + 1) : 0));
  };

  const handlePrev = () => {
    setSelectedIndex((i) => (items.length ? Math.max(0, i - 1) : 0));
  };

  return (
    <NewsWrapper id="news">
      <InnerContainer>
        <HeaderRow>
          <Title>Latest News</Title>
          <ArrowButtons>
            <ArrowButton onClick={handlePrev}>←</ArrowButton>
            <ArrowButton onClick={handleNext}>→</ArrowButton>
          </ArrowButtons>
        </HeaderRow>

        <CarouselOuter>
          <CarouselTrack
            style={{
              // width: `${(items.length || 1) * 90}%`,
              transform: `translateX(-${activeIndex * 100}%)`,
            }}
          >
            {items.map((n, i) => (
              <CarouselItem key={i}>
                <NewsCard onClick={() => setOpenSidebarIndex(i)}>
                  <NewsDate>{n.date}</NewsDate>
                  <NewsTitle>{n.title}</NewsTitle>
                  <NewsExcerpt>{n.excerpt}</NewsExcerpt>
                </NewsCard>
              </CarouselItem>
            ))}
          </CarouselTrack>
        </CarouselOuter>

        {items.length > 1 && (
          <DotsRow>
            {items.map((_, i) => (
              <Dot
                key={i}
                type="button"
                $active={activeIndex === i}
                onClick={() => setSelectedIndex(i)}
              />
            ))}
          </DotsRow>
        )}
      </InnerContainer>

      {activeItem && (
        <>
          <SidebarOverlay onClick={() => setOpenSidebarIndex(null)} />
          <SidebarPanel>
            <SidebarImageWrapper>
              <SidebarImage src={activeItem.image} alt={activeItem.title} />
              <SidebarClose onClick={() => setOpenSidebarIndex(null)}>
                ✕
              </SidebarClose>
            </SidebarImageWrapper>
            <SidebarBody>
              <SidebarDate>{activeItem.date}</SidebarDate>
              <SidebarTitle>{activeItem.title}</SidebarTitle>
              <SidebarContent>{activeItem.content}</SidebarContent>

              <SidebarActions>
                <SidebarButton
                  onClick={() => {
                    if (navigator.share) {
                      navigator.share({
                        title: activeItem.title,
                        text: activeItem.excerpt,
                        url: window.location.href,
                      });
                    }
                  }}
                >
                  Share
                </SidebarButton>
                <SidebarButton
                  onClick={() => {
                    navigator.clipboard.writeText(window.location.href);
                    // keep UX simple; toast system could be used here if desired
                  }}
                >
                  Copy Link
                </SidebarButton>
              </SidebarActions>

              <SidebarNavRow>
                <SidebarNavButton
                  onClick={() =>
                    setOpenSidebarIndex((i) => (i !== null && i > 0 ? i - 1 : i))
                  }
                  disabled={openSidebarIndex === 0}
                >
                  ← Previous
                </SidebarNavButton>
                <SidebarNavButton
                  onClick={() =>
                    setOpenSidebarIndex((i) =>
                      i !== null && i < items.length - 1 ? i + 1 : i
                    )
                  }
                  disabled={openSidebarIndex === items.length - 1}
                >
                  Next →
                </SidebarNavButton>
              </SidebarNavRow>
            </SidebarBody>
          </SidebarPanel>
        </>
      )}
    </NewsWrapper>
  );
};

export default News;

